/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetDailyActivityMonitoringLogHeaderById = zod.object({
  "id": zod.string().uuid().optional()
});

export type GetDailyActivityMonitoringLogHeaderById = zod.input<typeof GetDailyActivityMonitoringLogHeaderById>;
export type GetDailyActivityMonitoringLogHeaderByIdOutput = zod.output<typeof GetDailyActivityMonitoringLogHeaderById>;
